import React from 'react';
import { connect } from 'react-redux';
import { getRpmDeviceTypeLabel } from '../../constants/other';
import {
    getTopProgramChipLabel,
    getProgramChipStyle,
    getRpmEligibleChipStyle,
} from '../../utils/programChipHelpers';

const RpmUnverifiedProgramCell = ({ data, rpmDeviceTypes }) => {
    const programLabel = getTopProgramChipLabel(data);
    const deviceLabel = getRpmDeviceTypeLabel(rpmDeviceTypes, data.rpm_device_type_id);

    return (
        <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                {programLabel &&
                    <span style={getProgramChipStyle(programLabel)}>{programLabel}</span>
                }
                <span style={getRpmEligibleChipStyle()}>+ RPM Eligible</span>
            </div>
            {deviceLabel &&
                <div style={{ fontSize: 12, color: '#666' }}>
                    Device: {deviceLabel}
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    rpmDeviceTypes: state.queue.rpmDeviceTypes,
});

export default connect(mapStateToProps)(RpmUnverifiedProgramCell);
